
import "jquery/dist/jquery"
import "bootstrap/dist/js/bootstrap";
import 'bootstrap/js/dist/dropdown';
import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import { isMultiColorActive, defaultColor, themeColorStorageKey, isDarkSwitchActive } from "./constants/defaultValues";
import 'bootstrap/dist/css/bootstrap.css'; 

const color =
  (isMultiColorActive || isDarkSwitchActive) && localStorage.getItem(themeColorStorageKey)
    ? localStorage.getItem(themeColorStorageKey)
    : defaultColor;

localStorage.setItem(themeColorStorageKey, color);
document.body.style.overflowX = 'hidden';

let render = () => {
  // import('./assets/css/sass/themes/gogo.' + color + '.scss').then(x => {
    require('./AppRenderer');
  // });
};
render();